<template>
  <v-card style="width:816px; height:1056px" class="pa-8 mb-4" elevation="5">
    <slot name="content" />
  </v-card>
</template>

<script>
export default {
  name: 'VirtualPage',
}
</script>
